import axios from 'axios'

import { SLOW_REQUEST_CONFIG } from '../util/operationProgressUtil'

export const menusUrl = '/bff/menu-usuario'

export const recuperarMenus = (callback) =>
  axios.get(menusUrl, SLOW_REQUEST_CONFIG).then((response) => callback(response.data))
